<svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 16L9.77612 12.0014L14 8" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
<path d="M19 16L14.7761 12.0014L19 8" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
